import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import sharedStyles from '../styles';

const Container = styled.div`
  display: flex;
  margin-right: ${sharedStyles.spacing['spacing-1xs']};
`;

const StaticSvg = styled.img`
  display: block;
  height: 20px;
`;

function UploadedSvgIcon({ url, alt = 'notification icon' }) {
  return (
    <Container>
      <StaticSvg
        aria-hidden="true"
        src={url}
        alt={alt}
        width="100%"
        height="auto"
      />
    </Container>
  );
}

UploadedSvgIcon.propTypes = {
  url: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default UploadedSvgIcon;
